export default class ShareModal {
  constructor($el) {
    this.$el = $el;

    this.$modal = this.$el.querySelector('.share-modal__modal');
    this.$button = this.$el.querySelector('.share-modal__button');
    this.$close = this.$el.querySelector('.share-modal__close');

    this.classes = {
      modalActive: 'share-modal__modal--active',
      buttonActive: 'share-modal__button--active',
    };

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideEvent = this.onClickOutside.bind(this);

    this.$button.addEventListener('click', this.openModal.bind(this));
    this.$close.addEventListener('click', this.closeModal.bind(this));
  }

  openModal() {
    this.$modal.classList.add(this.classes.modalActive);
    this.$button.classList.add(this.classes.buttonActive);
    document.addEventListener('click', this.onClickOutsideEvent);
  }

  closeModal() {
    this.$modal.classList.remove(this.classes.modalActive);
    this.$button.classList.remove(this.classes.buttonActive);
    document.removeEventListener('click', this.onClickOutsideEvent);
  }

  onClickOutside(e) {
    if (e.target.closest('.share-modal') === this.$el) return;

    this.closeModal();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-share-modal').forEach(
    $shareModal => new ShareModal($shareModal),
  );
});
